const skillsData = [
  {
    title: 'Languajes',
    skills: [
      'HTML',
      'CSS',
      'Ruby',
      'JavaScript',
    ],
  },
  {
    title: 'Frameworks',
    skills: [
      'Bootstrap',
      'Ruby on rails',
      'Rspec',
      'Capybara',
      'Selenium',
    ],
  },
  {
    title: 'Skills',
    skills: [
      'Codepen',
      'Github',
      'Terminal',
    ],
  },
  {
    title: 'Soft skills',
    skills: [
      'Communication',
      'Problem solving',
      'Patience',
      'Adaptability',
    ],
  },
];

export default skillsData;
